import { render, staticRenderFns } from "./DemoFooter.vue?vue&type=template&id=1cf639d9&scoped=true"
import script from "./DemoFooter.vue?vue&type=script&lang=js"
export * from "./DemoFooter.vue?vue&type=script&lang=js"
import style0 from "./DemoFooter.vue?vue&type=style&index=0&id=1cf639d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf639d9",
  null
  
)

export default component.exports